import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { DashboardRoutingModule } from "./dashboard.routing";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { DashboardDomainService } from "app_dashboard/service/dashboard-domain.service";
import {TitleServiceModule} from "./service/title/title-service.module";

@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        ConfigurationResourceModule,
        TitleServiceModule,
    ],
    providers: [
        SearchParameterService,
        DatePipe,
        DashboardDomainService,
    ]
})
export class DashboardModule {
}
